import { Box, Container } from "@mui/material";
import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { ArrowBack, Person, Search } from "@mui/icons-material";

const Header = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: theme.spacing(2),
  borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
  backgroundColor: "#0058ff",
  position: "sticky",
  top: 0,
  zIndex: 1,
}));

// const Avatar = styled(Box)(({ theme }) => ({
//   width: 40,
//   height: 40,
//   borderRadius: "50%",
//   backgroundColor: "#f5f5f5",
// }));

const DistributorsLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const params: any = new URLSearchParams(location.search);
  const locationId = params.get("locationId");

  return (
    <Container maxWidth={false} disableGutters>
      <Header>
        <ArrowBack
          onClick={() =>
            location.pathname === "/distributors"
              ? window.postMessage("close")
              : navigate(-1)
          }
          sx={{ color: "#fff" }}
        />
        <Box sx={{ display: "flex", gap: 2 }}>
          <Search
            sx={{ color: "#fff" }}
            onClick={() =>
              navigate(`/search?locationId=${locationId}`, {
                state: { from: "/distributors" },
              })
            }
          />
          <Person sx={{ color: "#fff" }} />
        </Box>
      </Header>

      <Outlet />
    </Container>
  );
};

export default DistributorsLayout;
